import tw, { styled } from 'twin.macro';

export const Container = styled.div<{ isVisibleOnLargeScreenOnly: boolean }>`
  ${tw`hidden`}
  ${tw`container`}
  ${({ isVisibleOnLargeScreenOnly }) => isVisibleOnLargeScreenOnly && tw`lg:block`}
  ${({ isVisibleOnLargeScreenOnly }) => !isVisibleOnLargeScreenOnly && tw`md:block`}
`;

export const Wrapper = styled.div`
  ${tw`w-full h-[0px]`}
`;

export const Image = styled.img<{
  alignment: Queries.kontent_item_interstitial_elements_align_enum;
  verticalAlignment: Queries.kontent_item_interstitial_elements_vertical_alignment_enum;
}>`
  ${tw`relative`}
  ${tw`z-[0]`}
  ${({ alignment }) => {
    switch (alignment) {
      case 'window_left':
        return [tw`absolute`, tw`left-0`];
      case 'content_left':
        return [tw`translate-x-[-50%]`];
      case 'center':
        return [tw`mx-auto`];
      case 'content_right':
        return [tw`ml-auto`, tw`translate-x-[50%]`];
      case 'window_right':
        return [tw`absolute`, tw`right-0`];
    }
  }}
  ${({ verticalAlignment }) => {
    switch (verticalAlignment) {
      case 'bottom':
        return;
      case 'middle':
        return tw`translate-y-[-50%]`;
      case 'top':
        return tw`translate-y-[-100%]`;
    }
  }}
`;
